module.exports = __webpack_public_path__ + "img/blower4.73ae6b2c.svg";